import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

// Preload the LCP hero image with the correct variant for the current viewport.
// Vite resolves these to the hashed asset URLs at build time.
import heroDesktop from "./assets/homebg-1.webp";
import heroMobile from "./assets/homebg-mob-1.webp";

const preloadHero = () => {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.fetchPriority = "high";
  link.href = window.matchMedia("(min-width: 768px)").matches
    ? heroDesktop
    : heroMobile;
  document.head.appendChild(link);
};
preloadHero();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
